import { Navigate, useTypedParams } from '@sorare/routing';
import { ANY_SPORT_SCORES_MATCHES_DAY_GAMEID_BOX_SCORE } from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { idFromObject } from '@sorare/core/src/gql/idFromObject';

export const GameCenterDayGameIdPage = <
  Params extends { day: string; gameId: string },
>() => {
  const { generateSportContextPath } = useSportContext();
  const { day, gameId } = useTypedParams<Params>();

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_SCORES_MATCHES_DAY_GAMEID_BOX_SCORE,
        {
          params: {
            day,
            gameId: idFromObject(gameId),
          },
        }
      )}
      replace
    />
  );
};
